module.exports = __webpack_public_path__ + "img/rs.e0acf82f.svg";